import React from "react";
import clsx from "clsx";
import { BaseButton } from "src/components/ui/baseButton";
import { Text } from "src/components/ui/Text";
import { UploadFilesIcon } from "../../../../icons";

export const BrowseFileArea = ({ fullWidth, onUpload, disabled }) => {
  return (
    <div className="flex flex-col gap-2 justify-center h-full items-center bg-vekin-green-50 py-3.5 border-dashed border-2 rounded-lg border-vekin-green40">
      <UploadFilesIcon
        className={`w-7 h-7`}
        fill={!disabled ? "#1FA37C" : "#979797"}
        stroke={!disabled ? "#1FA37C" : "#979797"}
      />

      <Text
        data-theme="main"
        className={`bg-transparent text-center ${clsx({
          "w-[72px]": !fullWidth,
          "text-accent ": disabled,
          "text-secondary ": !disabled,
        })}`}
        variant="medium-10"
      >
        Drag and drop to upload asset image
      </Text>

      <BaseButton
        disabled={disabled}
        variant="primary"
        size="small"
        className={`!w-[6.4375rem] from-vekin to-vekin hover:from-vekin/50 hover:to-vekin/50`}
        onClick={!disabled ? onUpload : () => {}}
      >
        Browse image(s)
      </BaseButton>
    </div>
  );
};
